import React from "react";

const steps = [
    "Plan",
    "Business",
    "Location",
    "Photo",
    "Services",
    "Hours",
    "Review",
    "Account",
];

const OnBoardingSteps = ({ activeStep = 1 }) => {
    return (
        <div className="w-full max-w-[780px] mx-auto mb-[28px]">
            {/* Desktop */}
            <div className="hidden md:flex items-center justify-center">
                {steps.map((step, index) => {
                    const stepNumber = index + 1;
                    const isActive = stepNumber === activeStep;
                    const isCompleted = stepNumber < activeStep;

                    return (
                        <div
                            key={step}
                            className="flex items-center gap-[6px] last:flex-initial"
                            style={{
                                flex: stepNumber === steps.length ? "initial" : "1 1 0%",
                            }}
                        >
                            <div className="flex items-center gap-[6px] shrink-0">
                                <div
                                    className={`w-[26px] h-[26px] rounded-full flex items-center justify-center text-[11px] font-semibold transition-all ${isActive || isCompleted
                                            ? "bg-[#212326] text-white"
                                            : "bg-[#e4e5e7] text-[#9298a0]"
                                        }`}
                                >
                                    {stepNumber}
                                </div>

                                <span
                                    className={`text-[12px] transition-all ${isActive || isCompleted
                                            ? "font-semibold text-[#212326]"
                                            : "font-medium text-[#9298a0]"
                                        }`}
                                >
                                    {step}
                                </span>
                            </div>

                            {stepNumber !== steps.length && (
                                <div
                                    className={`flex-1 h-[2px] mx-[6px] rounded-full ${isCompleted ? "bg-[#212326]" : "bg-[#e4e5e7]"
                                        }`}
                                />
                            )}
                        </div>
                    );
                })}
            </div>

            {/* Mobile */}
            <div className="flex md:hidden items-center justify-center gap-[6px]">
                {steps.map((_, index) => {
                    const stepNumber = index + 1;
                    const isActive = stepNumber === activeStep;

                    return (
                        <div
                            key={stepNumber}
                            className={`h-[6px] rounded-full transition-all duration-300 ${isActive
                                    ? "bg-[#ff5323] w-[24px]"
                                    : "bg-[#e4e5e7] w-[6px]"
                                }`}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default OnBoardingSteps;